import React from "react";

interface Props {
  onClose: () => void;
  onConfirm: () => void;
  /**
   * Diferença de preço já formatada com a unidade ("R$ 20,00 por mês",
   * "R$ 120,00 por ano (12x de R$ 10,00 no cartão)"). null = não afirma valor.
   */
  extraPrice: string | null;
}

export const UpgradePlanModal: React.FC<Props> = ({
  onClose,
  onConfirm,
  extraPrice,
}) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center">
      <div className="bg-white rounded-xl max-w-sm w-full shadow-lg relative text-center">
        <button
          onClick={onClose}
          className="absolute cursor-pointer top-2 right-4 text-2xl text-white hover:text-gray-600"
        >
          ×
        </button>
        <img
          src="/banner-upgrade.png"
          alt="papagaio"
          className="mx-auto mb-4"
        />
        <h2 className="text-xl font-bold text-[#042B4E] mb-3">
          Mude para o plano Explorador
        </h2>
        <p className="text-sm text-[#595D69] mb-6 px-2">
          O plano Descoberta permite apenas 1 criança. <br /> <br />
          Alterando seu plano para o <strong>Explorador</strong>
          {extraPrice && (
            <>
              {' '}por mais <br />
              <strong>{extraPrice}</strong>
            </>
          )}
          , você pode adicionar mais uma criança e receber livros personalizados para cada uma todo mês!
        </p>
        <div className="flex gap-3 p-4 justify-center">
          <button
            onClick={onClose}
            className="text-[#9195A1] cursor-pointer px-5 py-2 rounded-md font-semibold hover:opacity-90"
          >
            Não, obrigado!
          </button>

          <button
            onClick={onConfirm}
            className="bg-[#5BB947] cursor-pointer text-white px-10 py-5 rounded-md font-semibold hover:opacity-90"
          >
            Alterar plano
          </button>
        </div>
      </div>
    </div>
  );
};
